<template>
    <div  class="customKanBan customKanBan-active" >
        
        <div  class="con">
          
              <div class="left-demo" id="left-demo" ref="dragContent">
                  <!--  -->
                  <div class="demo-bg-img1  demo-bg" v-show="switchValue">
                        <img :src="dialogImageUrl" width="100%" height="100%" >
                  </div>
                  <div class="demo-bg-mask demo-bg" v-show="maskChecked">
                      <img src="../../assets/customKanBan/mask.png" alt="" width="100%" height="100%" >
                  </div>
                  <div class="demo-bg-img2 demo-bg" :style="nowBgImg" @click.self="leftDemoClick"></div>
                  
                <div class="big-title" :style="fontSize" @mousedown="titleMove($event)">{{titleName}} </div>  
                <!--小模块-->
                  <div :class="['moveBox',{'you-active':item.type == 1},{'moveBox-active':moveBoxIndex == index}]" @mousedown="tagDraggable($event,index)"   
                  v-for="(item,index) in moveBoxList" :key="index" :id="'moveBox'+(index+1)" 
                  :style="item.info" @contextmenu.prevent="rightClick($event,index)" @click="moveBoxClick_fn(index)" >
                      
                      <div :class="['top-title',{'shape-active':shapeValue == '箭形'}]" :style="topTitleObj" v-if="item.type == 0"> 
                          <div class="delta" v-show="shapeValue =='箭形'" :style="deltaObj"></div>
                          <div class="straight-line" v-show="shapeValue =='直线'" :style="lineObj"></div> 
                          <img :src="item.iconImg" alt="" v-show="item.iconImg != '' && item.iconFlag"> <span :style="item.titleStyle">{{item.titleStyle.name}}</span> 
                      </div>
                      <!-- <el-popconfirm v-show="delFlag==index" title="确定要删除此模板吗？" @onConfirm.stop="del_fn(`moveBox${index+1}`)">
                          <template #reference> 
                              <span style="color:red" @click.stop="del_fn(`moveBox${index+1}`)">删除</span>
                          </template>
                          </el-popconfirm> -->
                      <div class="top-title2" v-if="item.type == 1"> 
                          <img :src="item.iconImg" alt="" v-show="item.iconImg != '' && item.iconFlag"> <span :style="item.titleStyle">{{item.titleStyle.name}}</span> 
                      </div>
                      <div class="small-icon1" v-if="item.type == 1 && item.cheekImgIndex == 0 && item.cheekImgType != '自定义'">
                        <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/dian1.png`)" alt="" class="img1">
                        <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/dian1.png`)" alt="" class="img2">
                        <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/dian2.png`)" alt="" class="img3">
                      </div>
                        <div class="small-icon2" v-if="item.type == 1 && item.cheekImgIndex == 3 && item.cheekImgType != '自定义'">
                        <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/line4.png`)" alt="" class="img4" style="height:1px">
                        <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/pie1.png`)" alt="" class="img1">
                        <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/pie2.png`)" alt="" class="img2">
                      </div>
                      <div class="small-icon2" v-if="item.type == 1 && item.cheekImgIndex == 2 && item.cheekImgType != '自定义'">
                        <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/line3.png`)" alt="" class="img4">
                      </div>
                      <div class="small-icon5" v-if="item.type == 1 && item.cheekImgIndex == 5 && item.cheekImgType != '自定义'">
                          <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/round.png`)" alt="" class="img1">
                          <img :src="require(`@/assets/customKanBan/${item.cheekImgType}模块/round.png`)" alt="" class="img2">
                      </div>
                      <!-- 自定义 -->
                      <div class="small-icon6" v-if="item.cheekImgType == '自定义'">
                          <div class="zidingyi-jianbian"></div>
                          <div class="ziding-line"></div>
                      </div>
                      
                      <div class="lineMoveDiv"   @mousedown="moveLineWidth($event,`moveBox${index+1}`,0,index)"></div>
                      <div class="lineMoveDiv2"  @mousedown="moveLineHeight($event,`moveBox${index+1}`,0,index)"></div>
                  </div>   
                

                  <!-- 折线图 -->
                  <div :class="['line-chart',{'chart-active':chartIndex == index}]" v-for="(item,index) in lineChartList" :key="index + 200" :style="item.info" 
                  @mousedown="chartDraggable($event,index,'折线图')"
                  @click="chartClick_fn(index,'折线图')" :id="'line-chart'+(index+1)">
                       <div :id="'proportion'+(index+1)" style="width:100%;height:100%"></div>
                       <div class="line-chart-move"   @mousedown="moveChartWidth($event,`line-chart${index+1}`,1,index)"></div>
                       <div class="line-chart-move2"   @mousedown="moveChartHeight($event,`line-chart${index+1}`,1,index)"></div>
                  </div>

                  <!-- 柱状图 -->
                  <div :class="['bar-chart',{'chart-active':barChartIndex == index}]" v-for="(item,index) in barChartList" :key="index + 250" :style="item.info" 
                  @mousedown="chartDraggable($event,index,'柱状图')"
                  @click="chartClick_fn(index,'柱状图')" :id="'bar-chart'+(index+1)">
                       <!-- <p >单位：</p> -->
                       <div :id="'proportionBar'+(index+1)" style="width:100%;height:100%"></div>
                       <div class="bar-chart-move"   @mousedown="moveChartWidth($event,`bar-chart${index+1}`,2,index)"></div>
                       <div class="bar-chart-move2"   @mousedown="moveChartHeight($event,`bar-chart${index+1}`,2,index)"></div>
                  </div>

                  <!-- 饼图 -->
                   <div :class="['pie-chart',{'chart-active':pieChartIndex == index}]" v-for="(item,index) in pieChartList" :key="index + 300" :style="item.info" 
                  @mousedown="chartDraggable($event,index,'饼图')"
                  @click="chartClick_fn(index,'饼图')" :id="'pie-chart'+(index+1)">
                       <!-- <p >单位：</p> -->
                       <div :id="'proportionPie'+(index+1)" style="width:100%;height:100%"></div>
                       <div class="pie-chart-move"   @mousedown="moveChartWidth($event,`pie-chart${index+1}`,3,index)"></div>
                       <div class="pie-chart-move2"   @mousedown="moveChartHeight($event,`pie-chart${index+1}`,3,index)"></div>
                  </div>

                  <!-- 单值 -->
                  <div :class="['single-value',{'single-active':singleIndex == index},{'fusingle':item.type == 1}]" v-for="(item,index) in singleList" :key="index + 350" :style="item.info"
                  @mousedown="singleDraggable($event,index)" @click="singleClick_fn(index)" :id="'single-value'+(index+1)">
                    <div class="single-item" v-if="item.type == 0">
                        <div class="single-title" :style="{'backgroundColor':item.titleBgColor,'color':item.titleColor,'fontSize':item.titleIcon}">
                          {{item.titleName}}
                        </div>
                        <div class="single-val" :style="{'backgroundColor':item.valBgColor,'color':item.valColor,'fontSize':item.valIcon}">
                          值
                        </div>
                    </div>
                    <div class="single-item" v-if="item.type == 1">
                        <div class="fuhe-origina" :style="item.yuanXY" @mousedown="singleItemDraggable($event,index)" v-show="item.switchVal"><span :style="item.yuanStyle" >
                          原值</span><span :style="item.yuanValStyle">{{item.originalValue}}</span></div>
                        <div class="fuhe-huan" :style="item.hangXY" @mousedown="singleItemDraggable($event,index)"><span :style="item.hangStyle">上{{item.timeVal == 'MON'? '月':'日'}}环比</span>
                        <span :style="item.huanValStyle" :class="item.sameCompareValue > 0 ? 'rise' : 'fall'">{{item.sameCompareValue > 0 ? '+' :'-'}}{{item.sameCompareValue}}</span></div>
                        <div class="fuhe-tong" :style="item.tongXY" @mousedown="singleItemDraggable($event,index)"><span :style="item.tongStyle">去年同比</span>
                        <span :style="item.tongValStyle"  :class="item.lastCompareValue > 0 ? 'rise' : 'fall'">{{item.lastCompareValue > 0 ? '+' :'-'}}{{item.lastCompareValue}}</span></div>
                    </div>
                    <div class="single-move" @mousedown="singleMoveLineWidth($event,`single-value${index+1}`,1,index)"></div>
                    <div class="single-move2" @mousedown="singleMoveLineHeight($event,`single-value${index+1}`,1,index)"></div>
                  </div>

                  <!-- 列表 -->
                  <div :class="['tabulation',{'tabulation-active':tabulationIndex == index},'tabulationone']" v-for="(item,index) in tabulationList" :key="index + 400" :style="item.info"
                  @click="tabulationClick_fn(index)" @mousedown="tabDraggable($event,index)" id="tabulation1">
                      
                       
                       <div class="tabulation-item" v-for="(t,i) in tabulationArr" :key="i">
                          <div class="tab-left">
                             <div class="grade warning" v-if="t.type == 'warning'" :style="item.warning">预警</div>
                             <div class="grade alarm" v-if="t.type == 'alarm'" :style="item.alarm">告警</div>
                             <div class="grade notice" v-if="t.type == 'notice'" :style="item.notice">通知</div>
                             <el-tooltip class="item" effect="dark" content="内容" placement="top">
                                 <div class="item-content" :style="item.con">内容</div>
                              </el-tooltip>
                          </div>
                          <div class="tab-time" :style="item.time">2023-5-22</div>
                       </div>
                        <div class="tabulation-move" @mousedown="singleMoveLineWidth($event,`tabulation1`,2,index)"></div>
                        <div class="tabulation-move2" @mousedown="singleMoveLineHeight($event,`tabulation1`,2,index)"></div>
                  </div>

                  <!-- 图库 -->
                  <div :class="['gallery-imgs',{'gallery-active':galleryIndex == index}]" v-for="(item,index) in galleryList" :key="index + 500" :style="item.info"
                   @mousedown="galleryDraggable($event,index)"
                  @click="galleryClick_fn($event,index)"
                  :id="'gallery-imgs'+(index+1)">
                       <div class="img-item">
                           <img :src="item.imgUrl" draggable="false">
                       </div>
                      <div class="gallery-move" @mousedown="singleMoveLineWidth($event,`gallery-imgs${index+1}`,3,index)"></div>
                      <div class="gallery-move2" @mousedown="singleMoveLineHeight($event,`gallery-imgs${index+1}`,3,index)"></div>
                  </div>

                  <!-- 进度条 -->
                  <div :class="['myelprogress',{'progress-active':progressIndex == index}]" v-for="(item,index) in progressList" :key="index + 600" :style="item.info"
                  :id="'myelprogress'+(index+1)" @click="progressClick_fn(index)"
                   @mousedown="progressDraggable($event,index)">
                       <div class="progress-item">
                          <el-progress :percentage="item.lastCompare" :color="item.lastColor" :format="format"></el-progress>
                       </div>
                        <div class="progress-item" :style="{'marginLeft':item.spacing}">
                           <el-progress :percentage="item.sameCompare" :color="item.sameColor" :format="format"></el-progress>
                        </div>
                         <div class="progress-move" @mousedown="singleMoveLineWidth($event,`myelprogress${index+1}`,4,index)"></div>
                       <!-- <span>环比{{item.lastCompare}}</span> -->
                       <!-- <span>同比{{item.sameCompare}}</span> -->

                  </div>

                  <!-- 说明文字 -->
                  <div :class="['mycaption',{'caption-active':captionIndex == index}]" v-for="(item,index) in captionList" :key="index + 650" :style="item.info" 
                  @mousedown="captionDraggable($event,index)"
                  :id="'mycaption'+(index+1)"
                  @click="captionClick_fn(index)">
                    <div>
                      <span :style="{'fontSize':item.fontSize,'color':item.color}">{{item.titleName}}</span>
                    </div>
                  </div>




                   

              </div>

        </div>
        <div class="el-loading-mask" v-show="loading" style="z-index: 9999;">
                        <div class="el-loading-spinner">
                            <svg viewBox="25 25 50 50" class="circular">
                                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                            </svg>
                           <p>正在渲染....</p>
                        </div>
             </div>
    </div>
</template>

<script>
import CircularJSON from 'circular-json'
import {previewData,getBIList} from "../../api/customKanBanApi";
export default {
     data(){
        return {
          loading:true,
          //右键菜单
          rightMenStyle:{},
          isRightMenu:false,
          rightChangeList:{},
          rightChangeType:"",
          beforeLeft:0,
          beforeTop:0,
          elementType:"",
          elementIndex:-1,

          captionList:[],//说明文字
          captionIndex:-1,
          captionObj:{},
          customColor: 'red',
          //进度条
          progressList:[],
          progressIndex:-1,
          progressObj:{},
          //进度条上
          //星号必填
          countNum:5,
          memo:"",
          dialogVisible:false,
          disabledFlag:true,

          dialogAdd:false,
          temp:{},
          dingshiqi:null,
          rules: {
                biName: [
                    { required: true, message: '请输入看板名称', trigger: 'blur' }
                ]
                },
          //以上是保存看板
          routeData:{},//路由参数
          galleryIndex:-1,//图库选中
          galleryList:[],//图库
          galleryObj:{},//点击图库图片
          zujianFlag:false,//组件操作
          screenFlag:false,//全屏/缩小
          //天气
          Weather:{},
          weathObj:{},
          weatherList:[],
          weathIndex:-1,
          weatherImg:"",
          setIntervalTimer:null,
          //时间
          timerList:[],
          trimerObj:{},
          setTimer:null,
          timerIndex:-1,
          nowTime:"",
          nowWeek:"",
          nowMin:"",
          //右击菜单
          rightMenuList:[
            {
              'name':'X',
              'key':'left'
            },
            {
              'name':'Y',
              'key':'top'
            },
            {
              'name':'宽',
              'key':'width'
            },
            {
              'name':'高',
              'key':'height'
            },
          ],
          eaitIndex:-1,
          nowInputVal:0,
          moveBoxIndex:-1,//当前选中模块的索引
          nowModulTitleObj:{},//当前选中的模块标题样式
          rightClickMenu:false,//右击出现菜单
            titleName:"大标题",
            settingFlag:false,//控制右侧小模块的弹出跟收起
            //小模块
            moveBoxList:[],
            //右边选项卡
            tabList:['框架','模块','组件','图表','单值','列表','进度条','图库','文字'],
            tabIndex:0,
            offsetWidth:0,//宽度
            offsetHeight:0,//高度
            delFlag:-1, //控制删除是否显示
            bgImgList:[
                {
                    'url':require('@/assets/customKanBan/blue.jpg'),
                    'urlTran':require('@/assets/customKanBan/blueTran.png'),
                },
                {
                    'url':require('@/assets/customKanBan/green.png'),
                    'urlTran':require('@/assets/customKanBan/greenTran.png'),
                },
                {
                    'url':require('@/assets/customKanBan/yellow.jpg'),
                    'urlTran':require('@/assets/customKanBan/yellowTran.png'),
                },
                {
                    'url':require('@/assets/customKanBan/qing.png'),
                    'urlTran':require('@/assets/customKanBan/qingTran.png'),
                },
                {
                    'url':require('@/assets/customKanBan/theme5.png'),
                    'urlTran':require('@/assets/customKanBan/theme5Tran.png'),
                },
                {
                    'url':require('@/assets/customKanBan/theme6.png'),
                    'urlTran':require('@/assets/customKanBan/theme6Tran.png'),
                },
                {
                    'url':require('@/assets/customKanBan/theme7.png'),
                    'urlTran':require('@/assets/customKanBan/theme7Tran.png'),
                },
                {
                    'url':require('@/assets/customKanBan/theme8.png'),
                    'urlTran':require('@/assets/customKanBan/theme8Tran.png'),
                },
                {
                    'url':require('@/assets/customKanBan/智慧工业园区.png'),
                },
            ],//背景数据
            //正在使用的背景
            nowBgImg:{},
            activeIndex:0,//高亮背景框
            bgImgPhoto:"",//背景图片
            maskChecked:false,//是否使用遮罩
            switchValue:false,//是否启动背景图片
            //标题字体大小
            sizeValue:24,
            fontSizeList:[],
            fontSize:{},
            //标题字体颜色
            titleColor:'#fff',
              dialogImageUrl: '',
            dialogVisible: false,
            coordinate:{},//新增小模块的坐标
            shapeValue:"矩形", //小模块标题形状
            moduleBgColor:true, //小模块标题是否渐变
            moduleTitleColor:"#407cdd",//小模块标题颜色
            modelTitleName:{},//小模块标题文字
            topTitleObj:{} ,//小模块标题样式
            lineObj:{},//直线样式
            deltaObj:{},//箭头三角形样式
            nowIcon:require(`@/assets/customKanBan/白色模块/icon1.png`),//当前图标
            copyData:[],//复制
            layerX:0,//粘贴的位置
            layerY:0,//粘贴的位置
            fullScreenStyle:[],//全屏样式
            renovateStyle:[], //刷新样式

            lineChartList:[],//折线图的数据
            barChartList:[],//柱状图的数据
            pieChartList:[],//饼图图的数据
            nowChartData:{},//当前选中的图表
            chartIndex:-1,//选中的折线图表模块
            barChartIndex:-1,//选中的柱状图模块
            pieChartIndex:-1,//选中的饼图图模块
            proportionListLine:[],//初始化折线图图例
            proportionListBar:[],//初始化柱状图图例
            proportionListPie:[],//初始化饼图图例
            chartType:"",

            singleList:[],//单值
            singleIndex:-1,//单值
            nowSingleData:{},
            tabulationList:[],//列表
            tabulationIndex:-1,
            tabulationArr:[],
            tabulationArrCopy:[
              {
                'type':"alarm",
              },
              {
                'type':"warning",
              },
            ],
            nowTabulationData:{}
        }
    },

    mounted() {
       this.getList()
  },

    methods:{

      //获取页面
      getList(){
        previewData({}).then(res => {
            // return
            //接口返回的数据
            var resultData = res.data.biViews
            // var list = res.data[0]
            console.log("数据",resultData);
            
            // var myExample = JSON.parse(res.data.staticResource)
            var myExample = CircularJSON.parse(res.data.staticResource)
            this.setExample(myExample[0])
            console.log("myExample[0]",myExample[0]);
            this.tranPercentage()
            // this.myHtml = list.content
            var that = this
              //折线图
              if(this.lineChartList.length != 0){
                setTimeout(() => {
                  that.lineChartList.forEach((item,index) => {
                        that.proportionListLine.push(echarts.init(document.getElementById(`proportion${index + 1}`)));
                        that.proportionListLine[index].setOption(that.lineChartList[index].optionData,true);
                  })
                },500)
              }
              //柱状图
              if(this.barChartList.length != 0){
                var barIndex = 0
                var lastCompare = [] //环比
                var sameCompare = [] //同比
                //先循环总体的柱状图数组
                // var num = 1
                // this.barChartList.splice(3,1)
                this.barChartList.forEach(item => {
                  item.optionData.legend.top = '87%'
                  //循环每个柱状图所绑定的变量
                  lastCompare = [] //环比
                 sameCompare = [] //同比
                  item.resParameter.resParameter.forEach(t => {
                    barIndex  = resultData.findIndex(v => v.tag == t.tag)
                    if(barIndex >= 0){
                         lastCompare.push(resultData[barIndex].data.lastCompareValue)
                         sameCompare.push(resultData[barIndex].data.sameCompareValue)
                          // console.log("循环",t,item);
                          // if(t.tag == item.resParameter)
                            // lastCompare.push(num++)
                            // sameCompare.push(num++)
                            

                    }
                   
                  })
                  // num++
                  // console.log("第几次循环",num,item);
                   item.optionData.series[0].data = lastCompare
                   item.optionData.series[1].data = sameCompare
                })
                console.log("this.barChartList",this.barChartList);
                setTimeout(() => {
                   that.barChartList.forEach((item,index) => {
                        that.proportionListBar.push(echarts.init(document.getElementById(`proportionBar${index + 1}`)));
                        that.proportionListBar[index].setOption(that.barChartList[index].optionData,true);
                  })
                },500)
              }
              //饼图
              if(this.pieChartList.length != 0){
                setTimeout(() => {
                  that.pieChartList.forEach((item,index) => {
                        that.proportionListPie.push(echarts.init(document.getElementById(`proportionPie${index + 1}`)));
                        that.proportionListPie[index].setOption(that.pieChartList[index].optionData,true);
                  })
                },500)
              }
              //单值
              if(this.singleList.length !=0){
                var singleIndex = 0
                this.singleList.forEach(item => {
                   singleIndex = resultData.findIndex(v => v.tag == item.tag)
                   if(singleIndex >= 0){
                     item.lastCompareValue  = resultData[singleIndex].data.lastCompareValue
                    item.sameCompareValue  = resultData[singleIndex].data.sameCompareValue
                    item.originalValue  = resultData[singleIndex].data.originalValue
                   }
                })
              }
              //进度条
              if(this.progressList.length != 0){
                  var proIndex = 0
                  this.progressList.forEach(item => {
                    proIndex = resultData.findIndex(v => v.tag == item.tag)
                    if(proIndex >= 0){
                       item.lastCompare  = resultData[proIndex].data.lastCompareValue
                       item.sameCompare  = resultData[proIndex].data.sameCompareValue
                       item.lastColor  = resultData[proIndex].data.lastCompareValue > 0 ? '#FF5C38' : '#25D09D'
                       item.sameColor = resultData[proIndex].data.sameCompareValue > 0 ? '#FF5C38' : '#25D09D'
                    }
                  })
              }
              this.loading = false
            

        })
  
      },
      
      // 转化实例方法
      setExample(data){
           //右键菜单
        this.captionList = data.captionList,//说明文字
        this.galleryList = data.galleryList,//说明文字
          //进度条
          this.progressList = data.progressList,
          //进度条上
          //星号必填
          this.countNum = data.countNum,
          this.memo = data.memo,
          this.dialogVisible = data.dialogVisible,
          this.disabledFlag = data.disabledFlag,
          this.temp = data.temp,
          this.dingshiqi = data.dingshiqi,
          this.rules =  data.rules,
          //以上是保存看板
          //天气
          this.Weather = data.Weather,
          this.weathObj = data.weathObj,
          this.weatherList =data.weatherList,
          this.weathIndex = data.weathIndex,
          this.weatherImg = data.weatherImg,
          this.setIntervalTimer = data.setIntervalTimer,
          //时间
          this.timerList = data.timerList,
          this.trimerObj = data.trimerObj,
          this.setTimer = data.setTimer,
          this.timerIndex = data.timerIndex,
          this.nowTime = data.nowTime,
          this.nowWeek = data.nowWeek,
          this.nowMin = data.nowMin,
          //右击菜单
          this.rightMenuList =data.rightMenuList,
          this.eaitIndex = data.eaitIndex,
          this.nowInputVal = data.nowInputVal,
          this.moveBoxIndex = data.moveBoxIndex,//当前选中模块的索引
          this.nowModulTitleObj = data.nowModulTitleObj,//当前选中的模块标题样式
          this.rightClickMenu = data.rightClickMenu,//右击出现菜单
            this.titleName = data.titleName,
            this.settingFlag = data.settingFlag,//控制右侧小模块的弹出跟收起
            //小模块
            this.moveBoxList = data.moveBoxList,
            //右边选项卡
            this.tabList = data.tabList,
            this.tabIndex = data.tabIndex,
            this.delFlag = data.delFlag, //控制删除是否显示
            this.bgImgList = data.bgImgList,//背景数据
            //正在使用的背景
            this.nowBgImg = data.nowBgImg,
            this.activeIndex = data.activeIndex,//高亮背景框
            this.bgImgPhoto = data.bgImgPhoto,//背景图片
            this.maskChecked = data.maskChecked,//是否使用遮罩
            this.switchValue = data.switchValue,//是否启动背景图片
            //标题字体大小
            this.sizeValue = data.sizeValue,
            this.fontSizeList = data.fontSizeList,
            this.fontSize = data.fontSize,
            //标题字体颜色
            this.titleColor = data.titleColor,
              this.dialogImageUrl =  data.dialogImageUrl,
            this.dialogVisible =  data.dialogVisible,
            this.coordinate = data.coordinate,//新增小模块的坐标
            this.shapeValue = data.shapeValue, //小模块标题形状
            this.moduleBgColor = data.moduleBgColor, //小模块标题是否渐变
            this.moduleTitleColor = data.moduleTitleColor,//小模块标题颜色
            this.modelTitleName = data.modelTitleName,//小模块标题文字
            this.topTitleObj = data.topTitleObj ,//小模块标题样式
            this.lineObj = data.lineObj,//直线样式
            this.deltaObj = data.deltaObj,//箭头三角形样式
            this.nowIcon =data.nowIcon,//当前图标
            this.copyData =data.copyData,//复制
            this.layerX = data.layerX,//粘贴的位置
            this.layerY = data.layerY,//粘贴的位置
            this.fullScreenStyle = data.fullScreenStyle,//全屏样式
            this.renovateStyle = data.renovateStyle, //刷新样式

            this.lineChartList = data.lineChartList,//折线图的数据
            this.barChartList = data.barChartList,//柱状图的数据
            this.pieChartList = data.pieChartList,//饼图图的数据
            this.nowChartData = data.nowChartData,//当前选中的图表
            this.chartIndex = data.chartIndex,//选中的折线图表模块
            this.barChartIndex = data.barChartIndex,//选中的柱状图模块
            this.pieChartIndex = data.pieChartIndex,//选中的饼图图模块

            this.chartType = data.chartType,

            this.singleList = data.singleList,//单值
            this.singleIndex = data.singleIndex,//单值
            this.nowSingleData = data.nowSingleData,
            this.tabulationList =data.tabulationList,//列表
            this.tabulationIndex = data.tabulationIndex,
            this.tabulationArr = data.tabulationArr,
            this.tabulationArrCopy = data.tabulationArrCopy,
            this.nowTabulationData = data.nowTabulationData
            this.quxiaoAll()
      },

      //把所有的px转化为百分比%
      tranPercentage(){
        //说明文字
       this.offsetWidth = document.getElementById("left-demo").offsetWidth
       this.offsetHeight = document.getElementById("left-demo").offsetHeight
           this.captionList.forEach(item => {
                    item.info.left = ((this.tranString(item.info.left) / this.offsetWidth) * 100).toFixed(1) + '%'
                    item.info.top = ((this.tranString(item.info.top) / this.offsetHeight) * 100).toFixed(1) + '%'
            })
        
         //进度条
        this.tranEverArr(this.progressList)
        //图库
         this.tranEverArr(this.galleryList)
        //模块
         this.tranEverArr(this.moveBoxList)
        //折线图
         this.tranEverArr(this.lineChartList)
        //柱状图
         this.tranEverArr(this.barChartList)
        //饼图
        this.tranEverArr(this.pieChartList)
        //单值
        this.tranEverArr(this.singleList)
        //列表
         this.tranEverArr(this.tabulationList)
      },
      tranString(str){
          return Number(str.replace(/px/g, ""))
      },
      //转换各数组的
      tranEverArr(forArr){
            forArr.forEach(item => {
                    item.info.width = ((this.tranString(item.info.width) / this.offsetWidth) * 100).toFixed(1) + '%'
                    item.info.left = ((this.tranString(item.info.left) / this.offsetWidth) * 100).toFixed(1) + '%'
                    item.info.height = ((this.tranString(item.info.height) / this.offsetHeight) * 100).toFixed(1) + '%'
                    item.info.top = ((this.tranString(item.info.top) / this.offsetHeight) * 100).toFixed(1) + '%'
                })
      },

     //取消全部高亮
      quxiaoAll(){
        this.captionIndex = -1
         this.moveBoxIndex = -1
        this.weathIndex = -1
        this.chartIndex = -1
        this.pieChartIndex = -1
        this.barChartIndex = -1
        this.tabulationIndex = -1
        this.singleIndex = -1
        this.galleryIndex = -1
        this.progressIndex = -1
        this.nowChartData = {}
        this.nowTabulationData = {}
        this.nowSingleData = {}
        this.galleryObj = {}
        this.captionObj = {}
        this.progressObj = {}
      },



      //以下是弃用的，但不可删除
       //说明文字
      caption_fn(val){
             
        // this.caption.push(obj)
      },
      //文字点击
      captionClick_fn(index){
        
      },
       captionDraggable(e,index){
            
          },
      //文字样式改变
      changCaption_fn(obj){
       
      },
      //进度条
      format(percentage) {
        return percentage < 0 ? `-${percentage}%` : `+${percentage}%`;
      },
      //进度条拖放
      progress_fn(val){
            
      },
      progressDraggable(e,index){
            
          },
      //进度条点击
      progressClick_fn(index){
        
      },
      changPro_fn(obj){
      
      },
      //编辑栏拖放
      formulaBar(e){
        
      },
      //图库拖放
      gallery_fn(val){
          
      },
      //图库点击
      galleryClick_fn(e,index){
        
      },
      //图库拖动
         galleryDraggable(e,index){
            
          },
      //图库改变
      changGallery_fn(obj){
           
      },

      
      //时间
      timer_fn(){
        
      },
      //为了解决点击菜单就消失
      addDel_fn(){},

      //输入框失去焦点或者按下回车
      blur_fn(val,index){
        
      },
      //点击复制
      copy_fn(index){
                 
      },
      
      //取消右击菜单跟模块高亮
      leftDemoClick(e){
         
      },
      //取消全部高亮
      quxiaoAll(){
        
      },
      moveBoxClick_fn(index){
        
      },
        //下载图片
       generateImages () {
           
        },
       
        //自定义宽度
        moveLineWidth(e,index,type,i) {
      
            
        },
        //自定义高度
        moveLineHeight(e,index,type,i){
                
          
        },
        //添加模块
        addMoveBox_fn(){
            
           
             
 
            
        },
        //删除模块
        del_fn(index,type){
           
        },
        // 模块拖拽
      tagDraggable (e,index) {
     
      },
      tagDraggable_fn(e,odiv,index,data){
       
         
      
      },
      //鼠标右键
      rightClick(e,index){
        

      },
      //大标题拖放
      titleMove(e){
       
    

      },
      //上传背景图片
       handlePictureCardPreview(file) {
        
      },
      //上传主题
      zhutiImg_fn(file){
         
      },
      //切换背景
      change_bg(index){
        
      },
      //启用禁用背景图片
      switch_fn(val){
        
      },
      //标题字体
      fontSize_fn(){
      
      },
      //字体颜色
      color_fn(val){
          
      },
      //小模块标题形状
      shape_fn(val){
        
      },
      //小模块标题图标
      nowIcon_fn(val){
       
      },
      //图标是否启用
      iconFlag_fn(val){
        
      },
      //小模块有边框类型
      nowCheek_fn(val){
       
      },
      //小模块标题背景渐变
      moduleTitle_fn(val){
          
      },
      //小模块标题背景颜色
      moduleTitleColor_fn(val){
        
      },
      //小模块小标题样式
      modelTitleName_fn(obj){
           
      },
      //小模块样式统一变动
      moduleStyle(){
       
      },
      //小模块拖放
      coordinate_fn(obj){
        
      },
      //组件拖放
      assembly_fn(val){
          
           
     
      },
      //组件天气拖放
      zujianTagDraggable(e,index,type){
        
      },
      //全屏/缩小/刷新
      screens_fn(val){  
        
      },
      //全屏/缩小/刷新
      screenRenovate_fn(val,obj){
        
      },

      //组件天气样式变化
      weathers_fn(val){
      

      },
       //组件时间样式变化
      timers_fn(val){
        

      },
      //操作提示
      operationTips(term,word){
          
      },
      

      //图表组件相关操作(以下)
      chart_fn(obj){
        
       
          
      },
      //图表拖动
      chartDraggable(e,index,type){
      
          
      },
      //点击图表
      chartClick_fn(index,type){
        
         
      },
      //改变图表
      changChart(obj){
        
      },
      //图表组件相关操作(以上)
      settingFlag_fn(val){
       
      },

      //单值操作(以下)
          //拖放
          single_fn(obj){
             
          },
          //点击
          singleClick_fn(index){
            
          },
          //改变单值
          changSingle_fn(obj){
           
          },
          //改变复合单值
          fusingleChange_fn(obj){
            
          },
          //拖动
          singleDraggable(e,index){
             
          },
          //复合单值拖动
          singleItemDraggable(e,index){
            
          },
          fusingleTuodong(e,odiv,data){
           
          },
          //自定义宽度
          singleMoveLineWidth() {
            
         
              
          },
          //自定义高度
          singleMoveLineHeight(){
                  
                
          },
          
      //单值操作(以上)
         
      //列表操作(以下)
          //拖放
          tabulation_fn(obj){
            
          },
          changtabulation_fn(obj){
            
             
          },
          tabulationClick_fn(){
              
          },
           //拖动
          tabDraggable(e,index){
           
          },
         
      //列表操作(以上)
      //保存看板
      preserve_fn(){
       
      },
      //确定保存看板
      save_fn(){
        

      }
        
    },
};
</script>

<style lang="scss" scoped>
// .customKanBan .left-demo .single-value.single-active {
//     border: 2px solid transparent !important;
//   }
.customKanBan {
  z-index: 100;
}
.customKanBan .left-demo .btns {
  display: none
}
.customKanBan-active {
        position: absolute;
        // z-index: 100;
        top: -45px;
        margin-top: 0px !important;
        height: 100% !important;
  }
  @import './customKanBanCopy.scss';
  
</style>